<template>
    <v-card class="py-0 my-0" color="transparent" v-if="canedit">
        <v-card-title class='py-0 my-0'>
            <!-- <code>{{test1}}</code> -->
                                    
            <v-btn
                fab                
                small
                v-on:click="onDialogOpen()"
                >
                <v-icon>
                    add
                </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
                v-if="attributes.withsearch"
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                solo                
            ></v-text-field>
            </v-layout>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            v-model="result"
            :select-all="attributes.withcheck"
            item-key="id"     
            class='py-0 my-0'
        >
            <template slot="headers" slot-scope="props">
                <tr>
                    <th v-if="attributes.withcheck">
                        <v-checkbox
                            :input-value="props.all"
                            :indeterminate="props.indeterminate"
                            primary
                            hide-details
                            @click.native="toggleAll"
                            
                        ></v-checkbox>
                    </th>
                    <th
                        v-for="header in props.headers"
                        :key="header.text"                           
                        class="text-left"
                    >                        
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template slot="items" slot-scope="props">
                <td v-if="attributes.withcheck">
                    <v-checkbox
                        v-model="props.selected"
                        primary
                        hide-details
                    ></v-checkbox>
                </td>
               
                
                
                <td>{{props.item.name}}</td>
                <td>{{props.item.specification}}</td>
                
                <td class="justify-center">
                    
                    <v-icon
                      small
                      v-on:click="deleteItem(props.item.id)"
                    >
                      delete
                    </v-icon>
                  </td>
            </template>
            <v-alert v-if="attributes.withsearch" slot="no-results" :value="true" color="error" icon="warning">
                Your search for "{{ search }}" found no results.
            </v-alert>            
        </v-data-table>        
        <form-search-dialog
            v-model="recipe"
            v-on:closeDialog="onDialogClosed"
            :dialog="dialog"
            :attributes="searchdialog"
            :vuexnamespace="vuexnamespace"
            >
        </form-search-dialog>
    </v-card>
</template>


<script>
import formsearchdialog from "./FormSearchDialog.vue"
export default {
    components: {
        'form-search-dialog': formsearchdialog
        
    },
    props:[
        'attributes',
        'vuexnamespace',            
    ],
    watch:{
        recipe(){
            if(this.recipe != null) {
                this.items.push(this.recipe)
                this.result.push(this.recipe.id)
                this.$store.commit(this.attributes.setter, this.result)
                
            }
        }
    },
    methods: {
        

        deleteItem (item) {
            
            const index = this.items.indexOf(item)
            confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1)
        },
        
        onDialogOpen() {   
            //console.log(this.dialog)  
            
            this.dialog = true
            this.itemid=undefined
            
        },
        onDialogClosed() {
            this.dialog=false
        },
                
        
    },
   
    computed: {
        
        //itemsnamespace (){return this.attributes.items.split('/')[0]},
        //itemsformdata (){return this.$store.getters[this.itemsnamespace + '/formdata']},
        items () {return this.$store.getters['projects/entities']}, 
        rowsrc () {return this.$store.getters[this.itemsnamespace + '/dataobject']},        
        parent_id () {return this.$route.params.id},        
        canedit () {return typeof this.$route.params.id != "undefined"},
        result() {return this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)},
        test1(){return this.$store.state.projects.data},                
    },
    
    data () {
        return { 
            //result:[],
            search: '',
            withsearch:false,
            withcheck:false,            
            dialog: false,
            recipe:null,
            'form-search-dialog': formsearchdialog,            
            itemid:undefined,
            headers: [
                {
                    text: 'Name',
                    value: 'name',                    
                    sortable:false
                },  
                {
                    text: 'Spezifikation',
                    value: 'specification',                    
                    sortable:false
                },  
            ],
            searchdialog:{
                items:'entities/entities', 
                hint:'Rezepte',
                lists: [
                    {
                        name:"Rezepte",
                        target:"entities",
                        variable:'name',
                        constraint:{
                            field: "entitycategory_id",
                            value: "1"
                        }
                    },
                    {
                        name:"Zutaten",
                        target:"entities",
                        variable:'name',
                        constraint:{
                            field: "entitycategory_id",
                            value: "2"
                        }
                    },  
                ]
            }
                
        }   
    },
    
    mounted() {           
        
                   
    }
    
}
</script>